export default __webpack_public_path__ + "static/media/error.8de34973.png";